// Action types
export const CHANGE_BROWSER_NOTIFICATION = 'change_browser_notification'
export const LOAD_NOTIFICATIONS = 'load_notifications'

export const changeBrowserNotification = (status) => {
  return {
    type: CHANGE_BROWSER_NOTIFICATION,
    payload: status
  }
}
